import { useState, useEffect } from "react";
import Post, { PostInterface } from "./Post";
import React from "react";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  getFirestore,
} from "firebase/firestore";
import { app } from "../../lib/firebase"; // Changed manually
import { likePost, unlikePost } from "../actions/index";
import RetrieveUserProfileById from "../../UserProfile/RetrieveUserProfileById";

interface PostListProps {
  currentUserId: string;
  currentUsername: string;
}

const PostList = ({ currentUserId, currentUsername }: PostListProps) => {
  const [posts, setPosts] = useState([] as PostInterface[]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const db = getFirestore(app);
    const postsQuery = query(
      collection(db, "posts"),
      orderBy("createdAt", "desc")
    );

    // Set up real-time listener for posts
    const unsubscribe = onSnapshot(
      postsQuery,
      (snapshot) => {
        const newPosts = snapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            content: data.content,
            userId: data.userId,
            username: data.username,
            likedBy: data.likedBy || [],
            commentIds: data.commentIds || [],
            createdAt: data.createdAt?.toDate() || new Date(),
            imageUrl: data.imageUrl,
            videoUrl: data.videoUrl,
          } as PostInterface;
        });
        setPosts(newPosts);
        setIsLoading(false);
      },
      (error) => {
        console.error("Error fetching posts:", error);
        setIsLoading(false);
      }
    );

    // Cleanup subscription
    return () => unsubscribe();
  }, []);

  // Function to handle liking a post
  const handleLike = async (postId: string) => {
    try {
      await likePost(postId, currentUserId);
    } catch (error) {
      console.error("Error liking post:", error);
    }
  };

  // Function to handle unliking a post
  const handleUnlike = async (postId: string) => {
    try {
      await unlikePost(postId, currentUserId);
    } catch (error) {
      console.error("Error unliking post:", error);
    }
  };

  if (isLoading) {
    return (
      <div
        style={{
          maxWidth: "672px",
          margin: "0 auto",
          padding: "32px 16px",
          textAlign: "center",
          color: "#666",
        }}
      >
        Loading posts...
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: "672px",
        margin: "0 auto",
        padding: "32px 16px",
      }}
    >
      {posts.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            color: "#666",
            padding: "20px",
          }}
        >
          No posts yet. Be the first to share something!
        </div>
      ) : (
        posts.map((post) => (
          <div
            key={post.id}
            style={{
              backgroundColor: "white",
              borderBottom: "1px solid #ccc",
              overflow: "hidden",
              marginBottom: "24px",
            }}
          >
            <Post
              post={post}
              currentUserId={currentUserId}
              currentUsername={currentUsername}
              onLike={handleLike}
              onUnlike={handleUnlike}
            />
          </div>
        ))
      )}
    </div>
  );
};

export default PostList;
